import Swiper from 'swiper/bundle'
import 'swiper/css'


let heroSwiper = null;

// swiper controls for carousel sections 
var init = false;

function swiperCard() {
    if (window.innerWidth <= 1080) {
        if (!init) {
            init = true;
            heroSwiper = new Swiper(".heroPromoSwiper", {
                direction: "horizontal",
                slidesPerView: "auto",
                centeredSlides: true,
                spaceBetween: 32,
                loop: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                pagination: {
                    el: '.swiper-pagination',
                } 
            });
        }
    } else if (init) {
        heroSwiper.destroy();
        init = false;
    }
}
swiperCard();
window.addEventListener("resize", swiperCard);

